import * as React from 'react';
import loadable from '@loadable/component';
import { Helmet } from 'react-helmet-async';
import { SEO_CONSTANTS } from '../../ListingPage/services/seo/constant';
import withMicroFrontendProps from 'Common/Microfrontend';

const Wishlist = loadable(() => import('mf-wishlist/Main'), { ssr: false });

const WishlistWithBellaProps = withMicroFrontendProps(Wishlist, 'mf-wishlist');

const WishlistMicroFrontend = () => (
    <div>
        <Helmet>
            <meta name={SEO_CONSTANTS.robotsMetaName} content={SEO_CONSTANTS.noIndexable} />
        </Helmet>
        <WishlistWithBellaProps />
    </div>
);

export default WishlistMicroFrontend;
